import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import CountWidget from './count-widget.component';
import { getCounters } from '../../services/reports.service';
import {
  CONTENT_ALIAS,
  DEFAULT_CHANNEL,
  SHOW_CONTENT_CHANNELS,
  SHOW_CONTENT_CATEGORIES,
  SHOW_CONTENT_VIDEOS,
  LS_ADMIN_USER_ID,
  SHOW_REPORTS_VIDEO_WATCH_SESSIONS,
} from '../../config/const.config';
import ROUTE_PATH from '../../config/routes.config';
import {
  getLocalValue,
  checkAdminUserRole,
} from '../../utils/local-cache.util';

const Counters = () => {
  const [counters, setCounters] = useState({
    channels: 0,
    videos: 0,
    categories: 0,
    sessions: 0,
  });

  useEffect(() => {
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);
    const adminUserRole = checkAdminUserRole();
    const params = {
      adminUserId,
      adminUserRole,
    };
    getCounters(params)
      .then((res) => {
        setCounters({
          ...counters,
          channels: res?.data?.channels || 0,
          videos: res?.data?.videos || 0,
          categories: res?.data?.categories || 0,
          sessions: res?.data?.sessions || 0,
        });
      })
      .catch(() => {
        // ignore
      });
  }, []);

  return (
    <Grid container spacing={3} mb={3}>
      {SHOW_CONTENT_CHANNELS && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.CHANNEL_PLURAL}`}
            total={counters.channels}
            color="secondary"
            icon="ic:twotone-checklist"
            navLink={ROUTE_PATH.CONTENT_CHANNELS}
          />
        </Grid>
      )}
      {SHOW_CONTENT_CATEGORIES && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.CATEGORY_PLURAL}`}
            total={counters.categories}
            color="secondary"
            icon="iconamoon:category"
            navLink={ROUTE_PATH.CONTENT_CATEGORIES}
          />
        </Grid>
      )}
      {SHOW_CONTENT_VIDEOS && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.VIDEO_PLURAL}`}
            total={counters.videos}
            color="secondary"
            icon="octicon:video-16"
            navLink={ROUTE_PATH.CONTENT_VIDEOS}
          />
        </Grid>
      )}
      {SHOW_REPORTS_VIDEO_WATCH_SESSIONS && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title="Video Watch Sessions"
            total={counters.sessions}
            color="secondary"
            icon="ic:outline-list-alt"
            navLink={ROUTE_PATH.REPORTS_WATCH_SESSIONS}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Counters;
